import { Component, computed, inject, signal, viewChild } from "@angular/core"
import { Router } from "@angular/router"
import { TourService } from "./tour.service"
import { TourAudioPlayerComponent } from "./tour-audio-player.component"
import { ProfileService } from "../user-profile/profile.service"
import { AudioStatus, IntroAnchor, RedlineMapAnchor, TourItemSegment } from "./tour.model"
import { faArrowRotateLeft, faChevronLeft, faChevronRight, faClose } from "@fortawesome/free-solid-svg-icons"
import { UiInheritDirective } from "ui-inherit"
import { PageToolbarService } from "../page-toolbar.service"
import { UiIconComponent } from "ui-icon"
import { WA_LOCAL_STORAGE, WA_WINDOW } from "@ng-web-apis/common"
import { RouteService, Section } from "../../services/route.service"
import { FirestoreReadService } from "../content/firestore-read.service"
import { TimelineService } from "../pages/timeline/timeline.service"
import { RedlineMapService } from "../pages/redline-map.service"
import { MapService } from "../map/map.service"
import { RegionsService } from "../../regions/regions.service"
import { regionsData } from "redlineLibs"

@Component({
  imports: [
    TourAudioPlayerComponent,
    UiInheritDirective,
    UiIconComponent,
  ],
  standalone: true,
  template: `
    <!--
        @defer (when isAdmin()) {
          <div (click)="$event.stopPropagation()">
            @if (showTourEditor()) {
              <e2e-tour-edit-items
                class="text-secondary"
                [activeIndexInput]="[currentItemIndex()]"
                (closeTourEditor)="setShowTourEditor(false)"
              />
            }
          </div>
        }
    -->

    @if (showTour()) {
      <!--
            <lib-ui-dialog
              (cancelAndClose)="setShowTour(false)"
              [scrollableBackground]="true"
              [transparentBackdrop]="true"
              position="top"
              [offset]="pageToolbarHeight() + 10"
            >
      -->
      <!--
              <div
                ngProjectAs="content"
                class="row"
                style="align-items: flex-start; padding: 10px"
              >
      -->
      <div class="row">
        <button
          class="btn btn-sm blue"
          (click)="setShowTour(false)"
        >
          <lib-ui-icon [icon]="faClose"/>
        </button>

        <button
          class="btn btn-sm blue"
          (click)="resetTour()"
        >
          <lib-ui-icon [icon]="faArrowRotateLeft"/>
        </button>

        <div
          class="column"
          style="flex: 1; align-items: center"
        >
          <div
            class="row"
            style="align-items: stretch; gap: 0; flex-wrap: nowrap"
          >
            <div
              class="row"
              style="justify-content: center; cursor: pointer; padding: 0 20px"
              (click)="changeToPreviousItem()"
            >
              <lib-ui-icon
                [icon]="faChevronLeft"
                [style.opacity]="currentItemIndex() > 0 ? 1 : 0.3"
              />
            </div>

            <e2e-tour-audio-player
              #tourAudioPlayer
              [item]="currentItem()"
              [itemIndex]="currentItemIndex()"
              (changeToNextItem)="changeToNextItem()"
              (changeToNextSegment)="changeToNextSegment()"
              (changeAudioStatus)="changeAudioStatus($event)"
              (processPlayerTime)="processPlayerTime($event)"
              inherit
            />

            <div
              class="row"
              style="justify-content: center; cursor: pointer; padding: 0 20px"
              (click)="changeToNextItem()"
            >
              <lib-ui-icon
                [icon]="faChevronRight"
                [style.opacity]="currentItemIndex() < tourItems().length - 1 ? 1 : 0.3"
              />
            </div>

          </div>
          <div (click)="clickTitle()">
            {{ currentItem()?.sectionTitle }}
            {{ currentItem()?.title }}
          </div>

        </div>
      </div>
      <!--
                   </div>
           -->

        <!--
              </lib-ui-dialog>
        -->
    }
  `,
  selector: "e2e-tour",
})
export class TourComponent {
  private window = inject(WA_WINDOW)
  private localStorage = inject(WA_LOCAL_STORAGE)
  private router = inject(Router)
  private tourService = inject(TourService)
  private profileService = inject(ProfileService)
  private pageToolbarService = inject(PageToolbarService)
  private firestoreReadService = inject(FirestoreReadService)
  private timelineService = inject(TimelineService)
  private redlineMapService = inject(RedlineMapService)
  private mapService = inject(MapService)
  private regionService = inject(RegionsService)
  private routeService = inject(RouteService)

  private tourAudioPlayer = viewChild<TourAudioPlayerComponent>("tourAudioPlayer")

  audioStatus = signal<AudioStatus>(AudioStatus.pause)
  audioStatusMessage = computed(() => (this.audioStatus() === "playing" ? "Pause the Tour" : "Resume the Tour"))
  currentItemIndex = this.tourService.currentItemIndex
  currentSegmentIndex = this.tourService.currentSegmentIndex
  previousItemIndex = computed(() => (this.currentItemIndex() ? this.currentItemIndex() - 1 : 0))
  nextItemIndex = computed(() =>
    this.currentItemIndex() < this.tourItems().length - 1 ? this.currentItemIndex() + 1 : this.tourItems().length,
  )
  currentItem = computed(() => this.tourItems_map().get(this.currentItemIndex()))
  previousItem = computed(() => this.tourItems_map().get(this.previousItemIndex()))
  nextItem = computed(() => this.tourItems_map().get(this.nextItemIndex()))
  interval = signal(0)
  showTourEditor = this.tourService.showTourEditor
  showTour = this.tourService.showTour
  tourItems = this.tourService.tourItems
  tourItems_map = this.tourService.tourItems_map
  // trackDuration = signal(0)
  isAdmin = this.profileService.isAdmin
  pageToolbarHeight = this.pageToolbarService.pageToolbarHeight

  changeToPreviousItem() {
    // console.log("changeToPreviousItem", this.previousItemIndex())
    this.tourService.setCurrentItemIndex(this.previousItemIndex())
    this.tourService.setCurrentItemTime(0)
    this.navigateToSection(0)
  }

  changeToNextItem() {
    // console.log("changeToNextItem", this.nextItemIndex())
    this.tourService.setCurrentItemIndex(this.nextItemIndex())
    this.tourService.setCurrentItemTime(0)
    this.navigateToSection(0)
  }

  navigateToSection(playerTime: number) {

    // find segment associated with player time by looping through all segments
    // and matching the first one that is greater than playerTime, or index = 0 if only one segment
    const currentItem = this.tourItems()[this.currentItemIndex()]
    for (let index = 0; index < currentItem.segments.length; index++) {
      const segment = currentItem.segments[index]
      const nextSegment = currentItem.segments[index + 1]

      if (!nextSegment || nextSegment.timestamp >= playerTime) {
        // console.log("segment", segment)
        const route =
          segment.section.toLowerCase().replace("_", "-") ||
          Section.INTRODUCTION.toLowerCase()

        switch (segment.section) {
          case Section.INTRODUCTION:
            switch (segment.anchor) {
              case IntroAnchor.WHAT_IS_REDLINING:
                break
            }
            this.tourService.scrollToElement(segment.anchor)
            break
          case Section.REDLINE_MAP:
            switch (segment.anchor) {
              case RedlineMapAnchor.WELCOME:
                this.activatePopup("visitedRedlineMap")
                break
              case RedlineMapAnchor.AREA_DESCRIPTION: {
                const regionProperties = this.regionService.regionProperties()
                if (regionProperties && !this.mapService.showMapModal()) {
                  this.mapService.setMarkerLocation(regionsData[this.routeService.region()].location)
                  this.mapService.unsetRegionProperties()
                  this.mapService.unsetStoryProperties()
                  this.mapService.setShowMapModal(true)
                  this.mapService.setRegionProperties(regionProperties)
                }
                this.closePopup()
                break
              }
              default:
                this.closePopup()
            }
            break
          case Section.TIMELINE: {
            this.timelineService.setScale(segment.zoomLevel)
            this.window.scrollTo(this.getScrollPosition(segment))
            break
          }
          case Section.STORIES_MAP:
            break
        }

        this.router.navigate([route], {})

        // Break out of the loop after this line executes
        break
      }
    }


    // const segment = this.tourItems()[this.currentItemIndex()].segments[this.tourService.currentSegmentIndex()]
    // // console.log(segment)
    // if (!segment) return
  }

  activatePopup(key: string) {
    this.localStorage.setItem(key, "false")
  }

  closePopup() {
    this.localStorage.setItem("visitedRedlineMap", "true")
    this.redlineMapService.setVisited(true)
  }

  changeToNextSegment() {
    // console.log("changeToNextSegment")
    this.navigateToSection(0)
  }

  changeAudioStatus(audioStatus: AudioStatus) {
    // console.log("changeAudioStatus", audioStatus)
    this.audioStatus.set(audioStatus)
  }

  processPlayerTime(currentTime: number) {
    this.navigateToSection(currentTime + 1)
  }

  exitTour(event: Event) {
    event.stopPropagation()
    this.setShowTour(false)
  }

  clickTitle() {
    // console.log("clickTitle")
    const tourAudioPlayer = this.tourAudioPlayer()
    if (this.isAdmin() && tourAudioPlayer) {
      tourAudioPlayer.pause()
      this.setShowTourEditor(true)
      // this.tourService.setShowTour(false)
    }
  }

  setShowTour(showTour: boolean) {
    this.tourService.setShowTour(showTour)
    // if (showTour) {
    //   this.load(this.currentItemIndex())
    // }
  }

  setShowTourEditor(showTourEditor: boolean) {
    this.tourService.setShowTourEditor(showTourEditor)
  }

  resetTour() {
    this.tourService.setCurrentItemIndex(0)
    this.tourService.setCurrentItemIndex(0)
    this.tourService.setCurrentItemTime(0)
  }

  getScrollPosition(segment: TourItemSegment) {
    const story = this.firestoreReadService.getStoryById(segment.contentId)
    if (!story) return { left: 0, top: 0, behavior: "smooth" as ScrollBehavior }

    const storyLeft = story.settings.position.left.px
    const storyWidth = story.settings.width.px
    const windowWidth = this.window.innerWidth / segment.zoomLevel

    let positionLeft = story.settings.position.left.px

    if (storyWidth < windowWidth) {
      positionLeft = storyLeft - ((windowWidth - storyWidth) / 2)
    }

    const positionTop = story.settings.position.top.px
    return {
      left: positionLeft * segment.zoomLevel,
      top: positionTop * segment.zoomLevel,
      behavior: "smooth" as ScrollBehavior,
    }
  }

  protected readonly faChevronRight = faChevronRight
  protected readonly faChevronLeft = faChevronLeft
  protected readonly faClose = faClose
  protected readonly faArrowRotateLeft = faArrowRotateLeft
}
